import * as React from "react";
import { Component } from "react";
import "./CheckBox.css";

interface IProps {
    Checked: boolean;
    OnClick: (e) => void;
    Label: string | JSX.Element;
    Color?: string;
    Disabled?: boolean;
    ClassNames?: string;
    LabelClassNames?: string;
}

export class CheckBoxComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { Checked, Color, OnClick, Disabled, ClassNames = "", LabelClassNames = "" } = this.props;

        return (
            <span
                className={`checkbox ${Color ? "checkbox--" + Color : ""} ${Disabled ? "checkbox--disabled" : ""} ${ClassNames}`}
            >
                <input
                    className="checkbox__input"
                    type="checkbox"
                    checked={Checked}
                    onChange={this.OnInputChange}
                    disabled={Disabled}
                    onClick={Disabled ? () => { } : OnClick}
                />
                <label className={`checkbox__label ${LabelClassNames}`}>{this.props.Label}</label>
            </span>
        );
    }

    private OnInputChange(evt) { }
}



// WEBPACK FOOTER //
// ./src/controls/CheckBox.tsx